import React, { useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./DesignBoxConfirmationPreviewPage.module.css";
import axios from "axios";

const DesignBoxConfirmationPreviewPage = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const { access } = JSON.parse(localStorage.getItem("authTokens"));
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const item = state?.item;

  return (
    <>
      <Header />
      <div className={styles.container}>
        <div className={styles.chip}>完成デザイン確認</div>
        <div className={styles.text}>
          完成デザイン表示日から1週間以内に「デザイン確定」または「修正希望」のボタンを押してください。
          変更受付期限以降は、修正はできませんのでご了承ください。
        </div>
        <div className={styles.imageContainer}>
          <div className={styles.imageTitle}>
            <p>{item?.product?.title}</p>
            <p>変更受付期限日 &nbsp; &nbsp; {item?.change_deadline}</p>
          </div>
          <img
            className={styles.image}
            src={
              process.env.REACT_APP_API_BASE_URL + item?.design?.preview_image
            }
            alt="preview"
          />
        </div>
        <div className={styles.finalDecision}>
          <div className={styles.finalDecisionText}>
            デザインを最終決定しますか？
          </div>
          <div className={styles.buttons}>
            <button
              className={styles.button1}
              onClick={() => {
                console.log({ order_item_id: id, status: "修正を希望する" });
                axios
                  .post(
                    `${process.env.REACT_APP_API_BASE_URL}/design/confirm`,
                    { order_item_id: id, status: "修正を希望する" },
                    { headers: { Authorization: `Bearer ${access}` } }
                  )
                  .then((data) => {
                    if (data.status === 200) {
                      navigate("/design-box/hope-to-fix");
                    } else {
                      setErrorMessage(
                        "The operation was not successfull. Try again."
                      );
                    }
                  })
                  .catch((e) => {
                    setErrorMessage(e.message);
                  });
              }}
            >
              修正を希望する
            </button>
            <button
              className={styles.button2}
              onClick={() => {
                axios
                  .post(
                    `${process.env.REACT_APP_API_BASE_URL}/design/confirm`,
                    { order_item_id: id, status: "はい" },
                    { headers: { Authorization: `Bearer ${access}` } }
                  )
                  .then((data) => {
                    if (data.status === 200) {
                      navigate("/design-box/confirm-message", {
                        state: { item: item },
                      });
                    } else {
                      setErrorMessage(
                        "The operation was not successfull. Try again."
                      );
                    }
                  })
                  .catch((e) => {
                    setErrorMessage(e.message);
                  });
              }}
            >
              はい
            </button>
          </div>
        </div>
        {errorMessage && (
          <p className="text-danger text-center font-weight-bold">
            {errorMessage}
          </p>
        )}
      </div>
      <Footer />
    </>
  );
};

export default DesignBoxConfirmationPreviewPage;
